import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ExportService {
    /**
     * Clean value
     * @param value - Value
     */
    clean(value: string): string {
        return value ? value.replace(/(\r\n|\n|\r)/g, ' ').trim() : '';
    }
}
